import { useI18n } from '../../lib/i18n';
import { StatCard } from '../ui/StatCard';
import {
  ConnectIcon,
  PhoneIcon,
  ClockIcon,
  AlertCircleIcon,
} from '../icons';
import type { ConnectSummary } from '../../lib/whatsappApi';

export interface ConnectStatCardsProps {
  summary: ConnectSummary | null;
  loading?: boolean;
}

export function ConnectStatCards({ summary, loading }: ConnectStatCardsProps) {
  const { t } = useI18n();

  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      <StatCard
        label={t('connect.stats.businessAccounts')}
        value={loading ? '—' : (summary?.businessAccounts ?? 0)}
        variant="indigo"
        icon={<ConnectIcon size={20} />}
      />
      <StatCard
        label={t('connect.stats.phoneNumbers')}
        value={loading ? '—' : (summary?.phoneNumbers ?? 0)}
        variant="green"
        icon={<PhoneIcon size={20} />}
      />
      <StatCard
        label={t('connect.stats.expiringSoon')}
        value={loading ? '—' : (summary?.expiringSoon ?? 0)}
        caption={t('connect.stats.expiringHint')}
        variant="amber"
        icon={<ClockIcon size={20} />}
      />
      <StatCard
        label={t('connect.stats.disconnected')}
        value={loading ? '—' : (summary?.disconnected ?? 0)}
        caption={summary?.disconnected ? t('connect.stats.disconnectedHint') : undefined}
        variant="rose"
        icon={<AlertCircleIcon size={20} />}
      />
    </div>
  );
}

export default ConnectStatCards;
